import React, { useEffect } from 'react'
import 'modal-pattern/dist/main.css'

interface ModalProps {
  isOpen: boolean
  title?: string
  onClose?: () => void
  clearBtn?: string
  submitBtn?: string
  onPrimary?: () => void
  onSecondary?: () => void
  primaryDisabled?: boolean
  secondaryDisabled?: boolean
  children?: React.ReactNode
  contentClassName?: string
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  title = '',
  onClose,
  clearBtn,
  submitBtn,
  onPrimary,
  onSecondary,
  primaryDisabled = false,
  secondaryDisabled = false,
  contentClassName = '',
  children,
}) => {
  useEffect(() => {
    // Emit open event when the modal is mounted so App's overlay shows
    if (isOpen && typeof globalThis !== 'undefined') {
      globalThis.dispatchEvent(new CustomEvent('app-modal-open'))
    }
    return () => {
      if (typeof globalThis !== 'undefined') {
        globalThis.dispatchEvent(new CustomEvent('app-modal-close'))
      }
    }
  }, [isOpen])

  if (!isOpen) return null

  const closeAndEmit = () => {
    if (typeof globalThis !== 'undefined') {
      globalThis.dispatchEvent(new CustomEvent('app-modal-close'))
    }
    onClose?.()
  }

  const handleBackdropClick = (e: React.MouseEvent<HTMLElement>) => {
    if (e.target === e.currentTarget) {
      closeAndEmit()
    }
  }

  const handleBackdropKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Escape') {
      closeAndEmit()
    }
  }

  const modal = (
    <div aria-hidden="false" className="modal-pattern" id="modal-manual-trig" data-ds-theme="vessel" data-ds-variant="windowed" data-analytics-location="modal-example-modal-two" style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2147483648 }}>
      <button
        className="modal-fade-screen"
        onClick={handleBackdropClick}
        onKeyDown={handleBackdropKeyDown}
        style={{ position: 'absolute', inset: 0, border: 'none', background: 'transparent', padding: 0, cursor: 'default' }}
        aria-label="Close modal"
      ></button>
      <div className="modal-container rows" style={{ position: 'relative', zIndex: 2147483649, width: '75rem', top: '82px' }}>
        <dialog className="modal-inner modal-icons-enabled columns-8 w-full" open aria-labelledby="modal-header-alert">

          <div className="modal-header">
            {title ? <h2 className="modal-title" id="modal-header-alert">{title}</h2> : <h2 className="modal-title" id="modal-header-alert">Modal</h2>}

            <button aria-label="Close" data-dismiss="x-close" data-analytics-type="button" onClick={closeAndEmit} data-analytics-click="Close [X] Modal">
              <img alt="close icon" src="/assets/images/close-outline.svg" width="30" height="30" />
            </button>
          </div>
          <div className="modal-content overflow-y-auto!">
            <div className={`overflow-y-auto! max-h-[60vh]! pr-4! ${contentClassName}`}>
              <div className="modal-content-body">

                <div className="modal-content-inner">
                  {children}
                </div>
              </div>
            </div>
            <div className="modal-actions">
              <div className="modal-buttons -right">

                <button
                  className={`button -inverted py-0!  modal-btn2 ${secondaryDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                  data-analytics-click="secondary button"
                  data-analytics-type="button"
                  data-success="btn2"
                  onClick={() => { if (!secondaryDisabled) { onSecondary?.() } }}
                  disabled={secondaryDisabled}
                >
                  {clearBtn}
                </button>
                { onPrimary && (
                  <button
                    className={`button -primary -light modal-btn1 py-0! modal__cancel-btn ${primaryDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                    data-analytics-click="Primary Button"
                    data-analytics-type="button"
                    data-success="btn1"
                    onClick={() => { if (!primaryDisabled) { onPrimary?.(); closeAndEmit() } }}
                    disabled={primaryDisabled}
                  >
                    {submitBtn}
                  </button>
                )}
              </div>
            </div>
          </div>
        </dialog>
      </div>
    </div>
  )

  return (
    <div>
      {modal}
    </div>
  )
}

export default Modal